import React from "react";
import LegalShell from "./LegalShell";
import { SITE } from "../../data";

export default function Privacidad() {
  return (
    <LegalShell title="Política de Privacidad" updated="Junio de 2026" path="privacidad" description="Cómo tratamos tus datos personales en España Eficiente (E²) conforme al RGPD y la LOPDGDD.">
      <p>
        Esta Política de Privacidad regula el tratamiento de los datos personales
        que facilitas a España Eficiente (E²) a través de este sitio web, conforme
        al Reglamento (UE) 2016/679 (RGPD) y a la Ley Orgánica 3/2018 (LOPDGDD).
      </p>

      <h2 className="text-xl font-bold text-foreground pt-2">1. Responsable del tratamiento</h2>
      <p>
        <strong>Manuel Antonio Evangelista Piris</strong> (DNI 61094433Q), titular
        de España Eficiente (E²). Contacto:{" "}
        <a href={`mailto:${SITE.email}`} className="text-espana-red font-bold">
          {SITE.email}
        </a>
        .
      </p>

      <h2 className="text-xl font-bold text-foreground pt-2">2. ¿Qué datos recogemos?</h2>
      <ul className="list-disc pl-6 space-y-1">
        <li>
          <strong>Formulario de contacto:</strong> nombre, correo electrónico,
          asunto y el contenido del mensaje que nos envías.
        </li>
        <li>
          <strong>Boletín / adhesión:</strong> tu correo electrónico, si decides
          suscribirte.
        </li>
        <li>
          <strong>Datos de navegación:</strong> datos técnicos y estadísticos de
          uso (ver la Política de Cookies).
        </li>
      </ul>

      <h2 className="text-xl font-bold text-foreground pt-2">3. ¿Con qué finalidad?</h2>
      <p>
        Atender y responder tus consultas y propuestas, gestionar el envío de
        novedades si te has suscrito y elaborar estadísticas agregadas de uso para
        mejorar la web. No se toman decisiones automatizadas ni se elabora perfil
        alguno.
      </p>

      <h2 className="text-xl font-bold text-foreground pt-2">4. Base legal</h2>
      <p>
        El tratamiento se basa en tu <strong>consentimiento</strong>, que prestas
        al enviar el formulario o suscribirte, y en el interés legítimo de
        responder a tu solicitud. Puedes retirar el consentimiento en cualquier
        momento.
      </p>

      <h2 className="text-xl font-bold text-foreground pt-2">5. Conservación</h2>
      <p>
        Conservamos tus datos el tiempo necesario para atender tu solicitud y,
        posteriormente, durante los plazos legalmente exigibles. Los datos del
        boletín se conservan hasta que solicites la baja.
      </p>

      <h2 className="text-xl font-bold text-foreground pt-2">6. Destinatarios</h2>
      <p>
        No cedemos tus datos a terceros, salvo obligación legal. Los datos se
        alojan en proveedores de servicios de infraestructura que actúan como
        encargados del tratamiento con las debidas garantías.
      </p>

      <h2 className="text-xl font-bold text-foreground pt-2">7. Tus derechos</h2>
      <p>
        Puedes ejercer tus derechos de acceso, rectificación, supresión, oposición,
        limitación y portabilidad escribiendo a{" "}
        <a href={`mailto:${SITE.email}`} className="text-espana-red font-bold">
          {SITE.email}
        </a>
        . También tienes derecho a reclamar ante la Agencia Española de Protección
        de Datos (
        <a
          href="https://www.aepd.es"
          target="_blank"
          rel="noopener noreferrer"
          className="text-espana-red font-bold"
        >
          www.aepd.es
        </a>
        ).
      </p>
    </LegalShell>
  );
}
